import React, { useState, useRef } from "react";
import KenInput from "../../../GlobalComponents/KenInput";
import { useStyles } from "../styles";
import { EventFormJsonFields } from "../../../interfaces/Events";
import { Controller, useFormContext } from "react-hook-form";
import { ValuesOfAny } from "../../../interfaces/Common";
import { InputAdornment } from "@mui/material";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";

const CustomDateField: React.FunctionComponent<{ fields: EventFormJsonFields }> = (props) => {
  const { fields } = props;
  const classes = useStyles();
  const { register, control } = useFormContext();
  const [fieldTypeSwitcher, setFieldTypeSwitcher] = useState<ValuesOfAny>({});
  const dateInputRef = useRef<HTMLInputElement>(null);

  const handleInputFieldSwitcher = (name: string, value: boolean) => {
    setFieldTypeSwitcher({ ...fieldTypeSwitcher, [name]: value });
  };

  const handleCalendarClick = () => {
    // Switch to date type and focus the input
    handleInputFieldSwitcher(`${fields.name}`, true);
    // Use setTimeout to ensure the DOM is updated before focusing
    setTimeout(() => {
      if (dateInputRef.current) {
        dateInputRef.current.focus();
        dateInputRef.current.showPicker?.(); // Modern browsers support showPicker()
      }
    }, 0);
  };

  // Get today's date in YYYY-MM-DD format for min attribute
  const todayDate = new Date().toISOString().split("T")[0];

  return (
    <Controller
      control={control}
      render={({ field: { onChange, value }, fieldState: { error } }) => {
        return (
          <div style={{ ...fields.fieldStyle }}>
            {fieldTypeSwitcher && fieldTypeSwitcher[`${fields.name}`] ? (
              <KenInput
                ref={dateInputRef}
                border
                customMargin
                placeholder={fields.placeholder}
                value={value}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  onChange(e);
                }}
                onBlur={() => {
                  handleInputFieldSwitcher(`${fields.name}`, false);
                }}
                onPaste={(e: { preventDefault: () => void }) => {
                  if (fields.name === "lastDatetoApply") {
                    e.preventDefault();
                  }
                }}
                error={error?.message}
                disableKeyDown
                labelClassName={classes.inputLableCustom}
                required={!!fields.validation?.required}
                {...fields}
                type={"date"}
                min={fields.name === "lastDatetoApply" ? todayDate : undefined}
              />
            ) : (
              <KenInput
                border
                customMargin
                placeholder={fields.placeholder}
                value={value}
                onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
                  onChange(e);
                }}
                onFocus={() => {
                  handleInputFieldSwitcher(`${fields.name}`, true);
                }}
                onPaste={(e: { preventDefault: () => void }) => {
                  if (fields.name === "lastDatetoApply") {
                    e.preventDefault();
                  }
                }}
                error={error?.message}
                disableKeyDown
                labelClassName={classes.inputLableCustom}
                required={!!fields.validation?.required}
                {...fields}
                InputProps={{
                  className: classes.inputStyles,
                  endAdornment: (
                    <InputAdornment position="end">
                      <CalendarTodayIcon 
                        style={{ height: "14px", cursor: "pointer" }} 
                        onClick={handleCalendarClick}
                      />
                    </InputAdornment>
                  ),
                }}
                type={"text"}
              />
            )}
          </div>
        );
      }}
      {...register(`${fields.name}`, {
        ...fields?.validation,
        validate: (value) => {
          if (fields.name === "lastDatetoApply" && value < todayDate) {
            return "You cannot select a past date.";
          }
          return true;
        },
      })}
    />
  );
};

export default CustomDateField;